import { createSelector } from 'reselect';
import { selectScene } from './scene';
import { ISceneDAO } from 'types/domain/scene';

const scene = selectScene;

export const selectSceneRotation = createSelector([scene], (scene: ISceneDAO) => {
  if (!scene) return null;
  return scene.image?.rotation || scene.video?.rotation || 0;
});
